module.exports = __webpack_public_path__ + "img/karl-kratz.9223f301.png";